import { PaginationResponse, api } from './api';

export enum MATCH_RULE_TYPE {
  AI = 0,
  RANGE = 1,
  BITMATCH = 2,
  OTHER = 3, // Specific for matching filter fields with other values
}

export const MATCH_RULE_TYPE_STR = Object.fromEntries(
  Object.entries(MATCH_RULE_TYPE).map(([key, value]) => [value, key])
);

export interface MatchRuleEntity {
  id: number;
  name: string;
  type: MATCH_RULE_TYPE;
  sequence: number;
  disabled: boolean;
  fields: [number, string?][];
  weightMale: number;
  weightFemale: number;
  grading: [string, string?][];
  prefills: string[];
  prompt: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface FindManyMatchRuleResponse extends PaginationResponse {
  data: MatchRuleEntity[];
}

export interface UpdateMatchRuleResponse {
  record: MatchRuleEntity;
  needReloadAll: boolean;
}

export interface TestMatchDto {
  userAId: string;
  userBId: string;
  id: number;
}

export interface RuleMatchResult {
  prompt: string;
  gradeA: string;
  gradeB: string;
  scoreA: number;
  scoreB: number;
  isDealBreaker: boolean;
}

export const matchRuleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    findManyMatchRules: builder.query<FindManyMatchRuleResponse, void>({
      query: () => ({
        url: '/match-rules',
        method: 'GET',
      }),
    }),
    createMatchRule: builder.mutation<
      UpdateMatchRuleResponse,
      Partial<MatchRuleEntity>
    >({
      query: (body) => ({
        url: '/match-rules',
        method: 'POST',
        body,
      }),
    }),
    updateMatchRule: builder.mutation<
      UpdateMatchRuleResponse,
      Partial<MatchRuleEntity>
    >({
      query: ({ id, ...body }) => ({
        url: `/match-rules/${id}`,
        method: 'PATCH',
        body,
      }),
    }),
    deleteMatchRule: builder.mutation<void, number>({
      query: (id) => ({
        url: `/match-rules/${id}`,
        method: 'DELETE',
      }),
    }),
    testRule: builder.mutation<RuleMatchResult, TestMatchDto>({
      query: ({ id, ...body }) => ({
        url: `/match-rules/${id}/test`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useFindManyMatchRulesQuery,
  useCreateMatchRuleMutation,
  useUpdateMatchRuleMutation,
  useDeleteMatchRuleMutation,
  useTestRuleMutation,
} = matchRuleApi;
